import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailButtonsContainer = styled.div<React.CSSProperties>`
  margin-top: ${28 * Screen.widthRatio}px;
`;

export default DetailButtonsContainer;
